import { Anchor } from 'antd';
import styled from 'styled-components';

export default styled(Anchor)`
	// Add your styles here
`;
